const STORAGE_KEY = 'carved_meta_points';
const POINT_THRESHOLDS = {
  5: 'VeryLowPoint',
  10: 'LowPoint',
  20: 'MedPoint',
  30: 'HighPoint'
};

const POINT_CLASSES = {
  'collection-flex-template-card-product': { points: 1, name: 'Product View' },
  'heart-outline.fav-heart': { points: 1, name: 'Favorite Add' },
  'heart-fill.fav-heart': { points: 1, name: 'Favorite Remove' },
  'remove-favorites-button': { points: 1, name: 'Favorite Page Remove' },
  'btn--add-to-cart': { points: 1, name: 'Add to Cart' },
  'card.filter-pill': { points: 1, name: 'Color Filter Click' },
  'btn.cart__checkout': { points: 1, name: 'Start Checkout' },
  'accordion-item': { points: 1, name: 'Product Accordion View' },
  'breadcrumbs-list': { points: 1, name: 'Breadcrumb Click' },
  'device-selector': { points: 1, name: 'Device Selector Click' },
  'device-match-content detected-device-link': { points: 1, name: 'Matched Device Click' },
  'pagination page': { points: 1, name: 'Pagination Click' }

};

// Initialize points
if (!localStorage.getItem(STORAGE_KEY)) {
  localStorage.setItem(STORAGE_KEY, '0');
}

async function updateCartAttribute(points, pointSources) {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'meta_points': points.toString(),
          'meta_points_sources': JSON.stringify(pointSources)
        }
      })
    });
    
    if (!response.ok) throw new Error('Failed to update cart');
    //console.log('Cart meta_points updated:', points, pointSources);
  } catch (error) {
    //console.error('Error updating cart attribute:', error);
  }
}

window.addMetaPoints = function(points, sourceName) {
  const currentPoints = parseInt(localStorage.getItem(STORAGE_KEY)) || 0;
  const pointSources = JSON.parse(localStorage.getItem(STORAGE_KEY + '_sources') || '{}');
  
  // Update point sources
  pointSources[sourceName] = (pointSources[sourceName] || 0) + points;
  
  const newPoints = currentPoints + points;
  //console.log(`Adding ${points} points from ${sourceName}. Current: ${currentPoints}, New: ${newPoints}`);
  //console.log('Point Breakdown:', pointSources);
  
  localStorage.setItem(STORAGE_KEY, newPoints.toString());
  localStorage.setItem(STORAGE_KEY + '_sources', JSON.stringify(pointSources));
  updateCartAttribute(newPoints, pointSources);

  // Check thresholds and fire FB events
  Object.entries(POINT_THRESHOLDS).forEach(([threshold, eventName]) => {
    if (currentPoints < threshold && newPoints >= threshold) {
      //console.log(`Threshold reached: ${eventName} at ${threshold} points`);
      //fbq('trackCustom', eventName);
      
      // Create event properties object with totalPoints
      const eventProperties = {
        totalPoints: newPoints
      };
      
      // Add each point source as a flat property
      Object.entries(pointSources).forEach(([source, points]) => {
        eventProperties[`Source_${source.replace(/\s+/g, '_')}`] = points;
      });

      klaviyo.push(['track', 'Meta Points', eventProperties]);
    }
  });
}

document.addEventListener('click', (e) => {
  const selector = Object.keys(POINT_CLASSES).map(c => {
    if (c.includes(' ')) {
      // For parent-child (space separated)
      return '.' + c.replace(' ', ' .');
    } else if (c.includes('.')) {
      // For multiple classes (dot separated)
      return '.' + c.replace('.', '.');
    } else {
      // For single class
      return '.' + c;
    }
  }).join(',');
  
  const element = e.target.closest(selector);
  
  if (element) {
    const matchedClass = Object.keys(POINT_CLASSES).find(className => {
      if (className.includes(' ')) {
        // For parent-child relationships
        const [parentClass, childClass] = className.split(' ');
        return element.classList.contains(childClass) && 
               element.closest('.' + parentClass) !== null;
      } else if (className.includes('.')) {
        // For multiple classes on same element
        return className.split('.').every(c => element.classList.contains(c));
      }
      // For single class
      return element.classList.contains(className);
    });
    
    if (!matchedClass) return;
    
    const pointInfo = POINT_CLASSES[matchedClass];
    const points = parseInt(element.dataset.metaPoints) || pointInfo.points;
    //console.log(`Click detected on ${matchedClass} element, worth ${points} points`);
    addMetaPoints(points, pointInfo.name);
  }
});

// Add this to see current points on page load
//console.log('Current total points:', localStorage.getItem(STORAGE_KEY));
//console.log('Current point breakdown:', JSON.parse(localStorage.getItem(STORAGE_KEY + '_sources') || '{}'));